<template>
  <div id="UI" class="UI clickThrough">
    <div id="top" v-if="showFilters" style="background-color: white" class="clickable">
      <MetadataFilters
        :filterMap
        :filterPropertyKeys
        @filterChange="(args) => $emit('filterChange', args)"
      />
    </div>

    <div id="UI" class="UI clickThrough">
      <div id="side" class="UI-mid">
        <div v-if="selectedMetadata" id="leftSide" class="metadata-container clickable pl-5">
          <MetadataView :metadata-object="selectedMetadata" :width="500" @close="catchCloseClick" />
        </div>
      </div>
      <div id="clearEvent" style="pointer-events: none"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { useDisplay } from 'vuetify';
import { useMetadataStore } from '@/stores/metadataStore';
import MetadataView from '@/components/MetadataView.vue';
import { useRouter } from 'vue-router';
import MetadataFilters from '@/components/MetadataFilters.vue';

export default defineComponent({
  props: {
    filterPropertyKeys: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    filterMap: {
      type: Object as PropType<Map<string, any[]>>,
      default: () => new Map(),
    },
  },
  components: { MetadataFilters, MetadataView },
  emits: ['filterChange'],
  computed: {
    showFilters() {
      const display = useDisplay();
      return display.mdAndUp.value;
    },
    selectedMetadata() {
      const mStore = useMetadataStore();
      return mStore.selectedMetadata || null;
    }
  },
  methods: {
    catchCloseClick() {
      const mStore = useMetadataStore();
      mStore.clearSelection();

      const router = useRouter();
      router.push({ name: 'home' })
    }
  },
})
</script>

<style scoped>
.UI {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 6fr;
  gap: 10px;
  padding: 5px;
  background-color: transparent;
}

.UI-mid {
  display: grid;
  grid-template-columns: 33% auto;
  grid-template-rows: 1fr;
  gap: 10px;
  height: 80%;
  pointer-events: none;
}

.clickable {
  pointer-events: auto;
}

.clickThrough {
  pointer-events: none;
  background-color: transparent;
}
</style>
